import React from 'react'
import { useState, useEffect, useContext } from 'react';
import { 
  Box,
  IconButton,
  Typography,
  Snackbar,
  Button,
  Grid,
  Avatar, 
  Divider,
  MenuItem,
  TextField,
  CircularProgress,
  ThemeProvider,
  CssBaseline,
  Modal,
  LinearProgress
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ColorModeContext, useMode } from "../theme";
import { fetchToken, fetchName } from '../auth/Token';
import AuthContext from "../auth/AuthProvider";
import SendIcon from '@mui/icons-material/Send';
import { api } from '../api' ;
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import Backdrop from '@mui/material/Backdrop';
import { decode } from 'base-64';
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import { useNavigate, useLocation } from 'react-router-dom';
import { styled, alpha  } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import DoneIcon from '@mui/icons-material/Done';
import Badge from '@mui/material/Badge';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import Menu from '@mui/material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ThumbDownOffAltRoundedIcon from '@mui/icons-material/ThumbDownOffAltRounded';
import ThumbUpOffAltRoundedIcon from '@mui/icons-material/ThumbUpOffAltRounded';
import InfoIcon from '@mui/icons-material/Info';
import { toast } from 'sonner';


const StyledMenu = styled((props) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '4px 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));

const FormatedDate = ({ value }) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };

  const formattedDate = date.toLocaleString('en-US', options);
  return <span>{formattedDate}</span>;
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(26, 32, 39, 0.5)' : 'rgba(255, 255, 255, 0.2)',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  borderRadius: '10px',
  marginBottom:'20px'
}));

const MessageBox_com = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    margin: '4px',
    maxWidth:'310px',
    display: 'flex',
    borderRadius: '20px',
    marginLeft: 'auto',
    display: 'flex', 
    flexDirection: 'column',
  }));
  
  const MessageBox_goi = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    margin: '4px',
    maxWidth:'310px',
    display: 'flex',
    borderRadius: '20px',
    display: 'flex', 
    flexDirection: 'column',
  }));

  const DetailsModal = ({item}) => {
    const [open_mod, setOpen_mod] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '580px',
      maxHeight: '150vh', 
      overflowY: 'auto', 
      bgcolor: 'background.paper',
      border: '1px solid #e7ecef',
      borderRadius: '7px',
      boxShadow: 24,
      p: 4,
    };
  
    const pic = (pic) => {
      const de = decode(pic);
      return `data:image/jpeg;base64,${btoa(de)}`;
    };
  
    const currencyFormat = new Intl.NumberFormat('en-GH', {
      style: 'currency',
      currency: 'GHS',
    });
  
    return(
        <>
            <Button
                variant="contained"
                disableElevation
                sx={{ borderRadius:5,ml:1,mr:2 }}
                color='warning'
                onClick={() => setOpen_mod(true)}
                endIcon={<InfoIcon />}
            >
                View order details
            </Button>
          <Modal
            open={open_mod}
            onClose={() => setOpen_mod(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
                <Grid container>
                  <Grid item xs={12} md={12}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle' sx={{textAlign:'center'}}><b>Order Details</b></Typography>
                  </Grid>
  
                  <Grid item xs={12} md={6}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle' sx={{textAlign:'center'}}><b>{item.order_type === "Buy"? "(Buying)": "(Selling)"}</b></Typography>
                  <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Commodity: <b>{item.commodity}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Order date: <b><FormatedDate value={item.date} /></b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Order type: <b>{item.order_type}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Bags: <b>{item.bags}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Grade: <b>{item.grade}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Unit: <b>{item.unit}</b>
                      </Typography>
                    </div>
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Note: 
                          <div>
                            <b>{item.message}</b>
                          </div>
                      </Typography>
                    </div>
  
                    {
                      item.order_type === "Sell"?
                      <div style={{display:'flex', marginTop:'5px'}}>
                        <Typography
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                        >
                          Selling Price: <b>{currencyFormat.format(item.open_price)}</b>
                        </Typography>
                      </div>:
                      null
                    }
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        {item.commodity} price on order date: 
                        <div>Grade A: <b>{currencyFormat.format(item.grade_a)}</b></div>
                        <div>Grade B: <b>{currencyFormat.format(item.grade_b)}</b></div>
                        <div>Grade C: <b>{currencyFormat.format(item.grade_c)}</b></div>
                      </Typography>
                    </div>
                  </Grid>
  
                  <Grid item xs={12} md={6}>
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Avatar
                        sx={{ width: 65, height: 65 }}
                        alt={item.member_name}
                        src={pic(item.member_image)}
                      />  
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Member name: <b>{item.member_name}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Member phone: <b>{item.member_phone}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Community: <b>{item.community.community_name}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Savings Group: <b>{item.association.association_name}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Kind: <b>{item.kind.association_type}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Cluster: <b>{item.cluster.cluster_name}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Society: <b>{item.society.society}</b>
                      </Typography>
                    </div>
  
                    <div style={{display:'flex', marginTop:'5px'}}>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='subtitle'
                      >
                        Warehouse: <b>{item.warehouse_details.warehouse}</b>
                      </Typography>
                    </div>
  
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Button
                      size='small'
                      variant='contained'
                      color='error'
                      onClick={()=>setOpen_mod(false)}
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
            </Box>
          </Modal>
        </>
    )
  }


const MessageArea = ({ nego_id, setOpen_Chat, fetch_chats, username, userimage, user_phone, agreed_price, agree, nego_status, order_id}) => {
    const [data, setData] = useState([]);
    const [final_price, setFinal_price] = useState(agreed_price);
    const [agreee, setAgreee] = useState(agree);
    const [message, setMessage] = useState('')
    const [order_details, setOrder_details] = useState([])
    const [openn, setOpenn] = useState(false);
    

    const fetch_all_orders = () => {
        api.get(`/account/get/one/orders/${order_id}`,{
          headers: {
            Authorization: 'Bearer ' + fetchToken()
          }
        }).then(function (response){
            setOrder_details(response.data?.all_orders);
        }).catch(function (error){
          console.log(error)
        })
      }
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const pic = (pic) => {
        const de = decode(pic);
        return `data:image/jpeg;base64,${btoa(de)}`;
    };

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });

    const handleCloses = () => {
        setOpenn(false);
      };
      const handleOpen = () => {
        setOpenn(true);
      };

    const negoStatusSet = (status) => {
        handleOpen()
        const data = new FormData()
        data.append('nego_id', nego_id);
        data.append('status', status);
    
        api.post('/account/end/negotiation', data, {
          headers: {
            Authorization: 'Bearer ' + fetchToken()
          }
        }).then(function (response){
            toast.success(response.data);
            fetch_messages();
            fetch_chats();
        }).catch(function (error){
          console.log(error)
        }).finally(function(){
            handleCloses()
        })
    }

    useEffect(()=>{
        const data = new FormData()
        data.append('nego_id', nego_id)
        data.append('agree_price', final_price)
        api.post('/account/set/agree/on/price', data, {
          headers: {
            Authorization: 'Bearer ' + fetchToken()
          }
        }).then(function (response){
            fetch_messages()
        }).catch(function (error){
          console.log(error)
        })
      },[final_price])

    const fetch_messages = () => {
        api.get(`/account/open/messages/${nego_id}`,{
            headers: {
                Authorization: 'Bearer ' + fetchToken()
            }
        }).then(function (response){
            setData(response.data);
        }).catch(function (error){
            console.log(error)
        }).finally(function (){
            fetch_chats()
        })
    }
    const make_agree =  () => {
        setAgreee(prevState => !prevState)
        const data = new FormData()
        data.append('nego_id', nego_id)
        data.append('agree', agreee)
        api.post('/account/agree/on/price', data, {
            headers: {
            Authorization: 'Bearer ' + fetchToken()
            }
        }).then(function (response){
            fetch_messages()
        }).catch(function (error){
            console.log(error)
        })
    }

    const sendMessage = (event) => {
        event.preventDefault()
        const data = new FormData()
        data.append('nego_id', nego_id);
        data.append('message', message);
    
        api.post('/account/send/message', data, {
          headers: {
            Authorization: 'Bearer ' + fetchToken()
          }
        }).then(function (response){
            fetch_messages();
            setMessage('');
        }).catch(function (error){
          console.log(error)
        })
      }

    useEffect(()=>{
        fetch_messages();
        fetch_all_orders();
    },[nego_id])

    useEffect(()=>{
        fetch_messages();
    const intervalId = setInterval(fetch_messages, 2000);
    return () => clearInterval(intervalId);
    },[nego_id])


    return(
        data.nego
        ?
            <>
                <Box sx={{marginRight:'auto'}}><IconButton onClick={() => setOpen_Chat()} color='error'><CancelIcon /></IconButton></Box>
                <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#f1faee', borderTopLeftRadius: '7px', borderTopRightRadius: '7px', paddingTop: 2, paddingBottom:2 }}>
                    <Avatar alt={username} src={pic(userimage)} sx={{ width: 65, height: 65 }}/>
                    <Typography variant='body2'><b>{username}</b></Typography>
                    <Typography variant='body2'><b>{user_phone}</b></Typography>
                </Box>
                <Box sx={{mt:1, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Agreed Price: {currencyFormat.format(final_price)} </b> 
                        <TextField
                            value={final_price}
                            onChange={e=>setFinal_price(e.target.value)}
                            label="Final Price"
                            type="number"
                            size='small'
                            disabled={nego_status !== 'Ongoing'?true:false}
                            sx={{ ml:1, borderRadius:7 }}
                        /> 
                        <IconButton disabled={nego_status !== 'Ongoing'?true:false} color={agreee === true?'primary':'success'} onClick={make_agree}><CheckCircleIcon /></IconButton>
                        
                        {
                        order_details[0]?
                        <DetailsModal  item={order_details[0]}/>
                        :<CircularProgress size={20}/>
                        }
                        <Button
                            id="demo-customized-button"
                            aria-controls={open ? 'demo-customized-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            variant="contained"
                            disableElevation
                            disabled={nego_status !== 'Ongoing'?true:false}
                            sx={{ borderRadius:5 }}
                            color='warning'
                            onClick={handleClick}
                            endIcon={<KeyboardArrowDownIcon />}
                        >
                            End negotiation
                        </Button>
                        <StyledMenu
                            id="demo-customized-menu"
                            MenuListProps={{
                            'aria-labelledby': 'demo-customized-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={()=>negoStatusSet('Success')} disableRipple>
                                <ThumbUpOffAltRoundedIcon />
                                Success
                            </MenuItem>
                            <MenuItem onClick={()=>negoStatusSet('Unsuccessful')} disableRipple>
                                <ThumbDownOffAltRoundedIcon />
                                Unsuccessful
                            </MenuItem>
                        </StyledMenu>

                    </Typography>
                </Box>
                <Box sx={{ mt:2,mb:1, maxHeight: "40vh", overflow:'auto', backgroundColor:'#ccdbdc', '&::-webkit-scrollbar': {
                                width: '7px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            }}}>
                    {
                    data?.chats && data?.chats.slice().reverse().map((item) => (
                    item.username === fetchName() ?
                    <MessageBox_com>
                    <div style={{ marginBottom:'3px' }}><Typography variant='subtitle'><b style={{marginRight:'5px'}}>You</b><FormatedDate value={item.datetime} /></Typography></div>
                        <div>
                            <Typography>
                            <span>{item.message}</span>
                            </Typography>
                        </div>
                    </MessageBox_com>
                    :
                        <MessageBox_goi>
                        <div style={{ marginBottom:'3px' }}><Typography variant='subtitle'><b style={{marginRight:'5px'}}>{item.username}</b><FormatedDate value={item.datetime} /></Typography></div>
                        <div>
                            <Typography>
                            <span>{item.message}</span>
                            </Typography>
                        </div>
                        </MessageBox_goi>
                    ))
                }
                </Box>
                <Box sx={{ display:'flex', flexDirection:'row' }}>
                {
                    nego_status !== "Ongoing"?
                    <Typography
                        variant='subtitle'
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        sx={{ margin:'auto' }}
                    >
                        Order Closed
                    </Typography>
                    :
                    <form onSubmit={sendMessage}>
                    <TextField
                        required
                        size='small'
                        sx={{ borderRadius:20,mt:2, minWidth:530}}
                        placeholder='Type a message'
                        value={message}
                        onChange={(e)=>setMessage(e.target.value)}
                    />
                    <IconButton sx={{marginTop:2}} size='small' onClick={sendMessage} color='secondary'><SendIcon /></IconButton>
                    </form>
                }
                    
                </Box>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={openn}
                    onClick={handleCloses}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </>
        :
            <Box sx={{ width: '100%' }}>
                <LinearProgress fourColor variant="indeterminate" />
            </Box>
    )
}



const Inbox = () => {
    const {  permissions } = useContext(AuthContext);
    const [chats, setChats] = useState([]);
    const [open_chat, setOpen_Chat] = useState();

    

    const fetch_chats = () => {
        api.get('/account/get/all/negotiations',{
            headers: {
                Authorization: 'Bearer ' + fetchToken()
            }
        }).then(function (response){
            setChats(response.data);
        }).catch(function (error){
            console.log(error)
        })
    }

    useEffect(()=>{
        fetch_chats();
      const intervalId = setInterval(fetch_chats, 2000);
      return () => clearInterval(intervalId);
    },[])


    const pic = (pic) => {
        const de = decode(pic);
        return `data:image/jpeg;base64,${btoa(de)}`;
    };

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });

    const openMessages = (nego_id, username, userimage, user_phone, agreed_price, agree, nego_status, order_id) => {
        setOpen_Chat(
            <MessageArea 
                nego_id={nego_id}
                setOpen_Chat={setOpen_Chat}
                fetch_chats={fetch_chats}
                username={username}
                userimage={userimage}
                user_phone={user_phone}
                agreed_price={agreed_price}
                agree={agree}
                nego_status={nego_status}
                order_id={order_id}
            />
        )
    }
  

  return (
     <div className="app">
       <main className="content">
           <Box sx={{m:5}}>
             {/* HEADER */}
             <Box display="flex" justifyContent="space-between" alignItems="center">
               <Header title="My Inbox" />
             </Box>
            {/* Chats */}
            <Grid container spacing={2}>
                <Grid item xs={12} md={5} lg={4}>
                    <Item>
                    {/* header */}
                        <Grid container spacing={1} sx={{ display:'flex' }}>
                            <Grid item xs={12} md={2}>
                                <Typography sx={{mt:'5px'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h4'>
                                    <b>Chats</b>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={10}>
                                <input
                                    placeholder='Search...'
                                    style={{ width: '100%', borderRadius: 18, border: '1px solid #ced4da', padding:'2vh' }}
                                    name='search'
                                />
                            </Grid>
                        </Grid>
                        <Divider variant='fullWidth' sx={{ mt:1,mb:'5px' }} />
                        {/* Chatlist */}
                        <List sx={{ width: '100%', maxHeight: 400, overflowY: 'scroll','&::-webkit-scrollbar': {
                                width: '7px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            }}}>
                            {
                                chats[0]? 
                                chats.map((item) => (<>
                                    <ListItemButton onClick={()=>openMessages(
                                        item.nego_id,
                                        item.username,
                                        item.user_image, 
                                        item.user_phone,
                                        item.agreed_price,
                                        item.agree,
                                        item.nego_status,
                                        item.order_id
                                    )}>
                                    <ListItem
                                        secondaryAction={
                                            item?.last_message?.read === false && item?.how === "go"?
                                            <Tooltip title='Unread'>
                                                <DoneIcon />
                                            </Tooltip>
                                            :item?.last_message?.read === true && item?.how === "go"?
                                            <Tooltip title='Read'>
                                                <DoneAllIcon sx={{ color:'#5887ff' }}/>
                                           </Tooltip>
                                           :item?.last_message?.read === false && item?.how === "come"?
                                            <Tooltip title='Unread'>
                                                <Badge badgeContent={item.unread} color="success" />
                                           </Tooltip>:item?.last_message?.read === true && item?.how === "come"?
                                           <Tooltip title='Read'>
                                                <DoneAllIcon sx={{ color:'#5887ff' }}/>
                                           </Tooltip>:null
                                        }
                                    alignItems="flex-start">
                                        <ListItemAvatar>
                                        <Avatar alt={item.username} src={pic(item.user_image)} />
                                        </ListItemAvatar>
                                        <ListItemText
                                        primary={item.username}
                                        secondary={
                                            <React.Fragment>
                                            <Typography
                                                sx={{ display: 'inline' }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                            >
                                                <Chip label={`Negotiation ${item.nego_status}`}  size="small" color={
                                                    item.nego_status === "Ongoing"?"secondary":
                                                    item.nego_status === "Success"?"success":"error"
                                                    } variant='filled'/>
                                            </Typography>
                                                    <div>
                                                        {item?.last_message?.message.length > 50 ? item?.last_message?.message?.slice(0, 50) + "..." : item?.last_message?.message}
                                                    </div>
                                                </React.Fragment>
                                            }
                                            />
                                        </ListItem>
                                </ListItemButton>
                            <Divider variant="inset" component="li" />

                            </>
                                ))
                                :
                                <Typography
                                    variant='subtitle'
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    sx={{ margin:'auto' }}
                                >
                                    <CircularProgress size={10}/><b> No open chats (Consider setting agregators for warehouse with orders)</b>
                                </Typography>
                            }
                         
                        </List>
                    </Item>
                </Grid>

                <Grid item xs={12} md={7} lg={8}>
                    <Item>
                        {
                            open_chat?
                            open_chat:
                            <Typography
                                variant='subtitle'
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                sx={{ margin:'auto' }}
                            >
                                <b>Select chat to open messages</b>
                            </Typography>
                        }
                    </Item>
                </Grid>
            </Grid>
           </Box>
       </main>
     </div>
  )
}

export default Inbox
